import * as React from 'react';

function SvgReferralEmpty(props) {
  return (
    <svg width={320} height={270} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M160.35 234.8c80.275 0 145.35-3.022 145.35-6.75s-65.075-6.75-145.35-6.75C80.075 221.3 15 224.322 15 228.05s65.075 6.75 145.35 6.75z"
        fill="#EBEFF2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M180.34 165.525h-71.049v63.854h71.049v-63.854z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.608 187.091l9.926-11.574 2.26-11.084c1.37-6.714 8.695-10.342 14.866-7.363l-3.572 15.766a38.467 38.467 0 01-9.176 17.514l-2.863 3.12-11.441-6.379z"
        fill="#F8AE9D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M186.375 167.504a7.536 7.536 0 1111.712-9.487l10.037 12.391-11.715 9.483-10.034-12.387z"
        fill="#FCCE01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.655 204.805h38.258l-5.413-39.736a14 14 0 00-12.095-11.993l-8.55-1.092a12.356 12.356 0 00-9.917 3.156 12.35 12.35 0 00-3.982 9.614l1.699 40.051z"
        fill="#FCCE01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.005 147.294s3.246-11.804 3.843-14.189c.598-2.386-.93-3.973-3.007-3.179-2.264-2.614-11.119-6.802-14.745-5.512-3.625 1.289-4.857 7.034-.689 9.75 4.169 2.716 14.598 13.13 14.598 13.13z"
        fill="#191847"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M175.055 131.424l-.931 10.084a6.923 6.923 0 006.15 7.519l-.534 8.188 8.783-2.519.52-11.458 1.272.304a2.602 2.602 0 002.421-.669l.237-.232a2.2 2.2 0 00-1.028-3.71 2.203 2.203 0 00-1.519.185l-1.383.716a24.841 24.841 0 01-12.986-7.335l-1.002-1.073z"
        fill="#F8AE9D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.471 163.052l.465 3.564c.452 3.469.285 6.99-.493 10.4l-9.618 42.156s-2.17-5.342-2.17-14.367c0-9.025.68-40.166.68-40.166l11.136-1.587z"
        fill="#F4C700"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.871 163.354a7.525 7.525 0 018.928-5.799 7.527 7.527 0 015.796 8.924l-3.321 15.643-14.722-3.134 3.319-15.634z"
        fill="url(#referral-empty_svg__paint0_linear_35_7633)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.871 163.354a7.525 7.525 0 018.928-5.799 7.527 7.527 0 015.796 8.924l-3.321 15.643-14.722-3.134 3.319-15.634z"
        fill="#FCCE01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M236.445 172.514l24.356 43.334a8.18 8.18 0 011.033 4.52l1.228 3.965h12.455l-4.885-6.228a8.071 8.071 0 01-1.114-1.908l-18.037-43.683h-15.036z"
        fill="#F8AE9D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M184.488 208.366l.828 8.359c.656 6.626 6.353 11.599 13.007 11.354a35.016 35.016 0 0028.598-16.752l15.073-24.705 8.345 13.39 15.985-1.611-12.164-22.655c-6.961-12.964-24.355-15.737-35.001-5.58l-32.751 31.244-1.92 6.956z"
        fill="#2F3676"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.656 175.232l23.72 42.295a8.002 8.002 0 011.007 4.412l1.196 3.87h12.13l-4.742-6.057a8.143 8.143 0 01-1.111-1.907L232.3 175.232h-14.644z"
        fill="#F8AE9D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M241.005 219.029l13.037-.864 1.402 5.927c5.799 1.601 8.166 3.026 7.103 4.274l-20.178.008-1.364-9.345z"
        fill="#191847"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M260.754 219.029l13.037-.864 1.403 5.927c5.798 1.601 8.165 3.026 7.102 4.274l-20.178.008-1.364-9.345z"
        fill="#191847"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.057 210.139l.884 8.865a11.925 11.925 0 0012.302 10.734 33.134 33.134 0 0016.601-5.175 33.133 33.133 0 0011.692-12.872l12.618-24.731 10.254 16.272 14.308-2.168-9.755-20.903c-6.43-13.777-24.467-17.207-35.504-6.751l-31.481 29.822-1.919 6.907z"
        fill="#2F3676"
      />
      <path d="M214.284 163.19H193.09a1.927 1.927 0 00-1.927 1.927h23.121v-1.927z" fill="#38B2A6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.729 142.733a3.646 3.646 0 013.577-2.941h35.393a1.226 1.226 0 011.199.961c.041.18.04.368-.002.548l-5.249 22.47-38.376.985h-.876l4.334-22.023z"
        fill="#2B4A47"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.457 142.535a3.646 3.646 0 013.577-2.948h36.3a1.626 1.626 0 011.25.59 1.611 1.611 0 01.34 1.34l-3.831 19.669a4.857 4.857 0 01-4.77 3.931h-37.265l4.399-22.582z"
        fill="#38B2A6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M230.18 155.965a3.373 3.373 0 10-.002-6.746 3.373 3.373 0 00.002 6.746z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M203.531 163.138l-2.459-2.452c-3.257-3.248-8.644-2.83-11.36.883l-14.313 24.726.734-4.173-11.687-2.545-1.502 10.587a10.175 10.175 0 0019.377 5.554l14.448-32.58h6.762z"
        fill="#F8AE9D"
      />
      <path
        d="M120.668 160.782H48.781c-11.009 0-19.933 8.924-19.933 19.932s8.924 19.932 19.933 19.932h71.887c11.008 0 19.932-8.924 19.932-19.932s-8.924-19.932-19.932-19.932z"
        fill="#fff"
        stroke="#F2F2F2"
        strokeWidth={4}
      />
      <path
        d="M65.119 180.714c0-8.843-7.169-16.011-16.011-16.011-8.843 0-16.012 7.168-16.012 16.011s7.169 16.011 16.012 16.011c8.842 0 16.01-7.168 16.01-16.011z"
        fill="#89C5CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.384 187.431v1.07c0 .591-.474 1.071-1.057 1.071H42.65c-.583 0-1.057-.48-1.057-1.071v-1.087c0-3.24 3.654-5.345 7.396-5.345s7.396 2.106 7.396 5.345v.017zm-4.743-14.767a3.737 3.737 0 011.099 2.652 3.75 3.75 0 01-6.405 2.653 3.75 3.75 0 012.653-6.404 3.751 3.751 0 012.653 1.099z"
        fill="#fff"
      />
      <path
        d="M126.386 169.931H70.511a1.797 1.797 0 100 3.594h55.875a1.798 1.798 0 100-3.594zM126.386 178.753H70.511a1.797 1.797 0 000 3.595h55.875a1.798 1.798 0 000-3.595zM126.386 187.576H70.511a1.797 1.797 0 000 3.594h55.875a1.797 1.797 0 100-3.594z"
        fill="#F2F2F2"
      />
      <path
        d="M128.375 107.796H56.488c-11.008 0-19.932 8.924-19.932 19.932s8.924 19.932 19.932 19.932h71.887c11.009 0 19.933-8.924 19.933-19.932s-8.924-19.932-19.933-19.932z"
        fill="#fff"
        stroke="#F2F2F2"
        strokeWidth={4}
      />
      <path
        d="M72.826 127.728c0-8.843-7.169-16.012-16.011-16.012-8.843 0-16.011 7.169-16.011 16.012 0 8.842 7.168 16.011 16.01 16.011 8.843 0 16.012-7.169 16.012-16.011z"
        fill="#89C5CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.091 134.445v1.07c0 .591-.473 1.071-1.056 1.071H50.355c-.583 0-1.056-.48-1.056-1.071v-1.088c0-3.239 3.653-5.344 7.395-5.344 3.742 0 7.396 2.106 7.396 5.344v.018zm-4.743-14.768a3.753 3.753 0 01-4.088 6.119 3.748 3.748 0 01-2.316-3.466 3.756 3.756 0 011.099-2.653 3.753 3.753 0 015.305 0z"
        fill="#fff"
      />
      <path
        d="M134.094 116.945H78.218a1.797 1.797 0 000 3.594h55.876a1.797 1.797 0 100-3.594zM134.094 125.767H78.218a1.797 1.797 0 000 3.594h55.876a1.797 1.797 0 100-3.594zM134.094 134.59H78.218a1.797 1.797 0 000 3.594h55.876a1.797 1.797 0 100-3.594z"
        fill="#F2F2F2"
      />
      <path
        d="M148.606 54.81H76.719c-11.008 0-19.932 8.923-19.932 19.932 0 11.008 8.924 19.932 19.932 19.932h71.887c11.009 0 19.933-8.924 19.933-19.932 0-11.009-8.924-19.933-19.933-19.933z"
        fill="#fff"
        stroke="#F2F2F2"
        strokeWidth={4}
      />
      <path
        d="M93.057 74.742c0-8.843-7.169-16.011-16.012-16.011-8.842 0-16.01 7.168-16.01 16.011s7.168 16.011 16.01 16.011c8.843 0 16.012-7.168 16.012-16.011z"
        fill="#89C5CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.322 81.459v1.07c0 .591-.474 1.071-1.057 1.071H70.587c-.583 0-1.057-.48-1.057-1.07V81.44c0-3.24 3.654-5.344 7.396-5.344s7.396 2.106 7.396 5.344v.018zm-4.743-14.767a3.752 3.752 0 11-5.306 5.306 3.752 3.752 0 015.306-5.306z"
        fill="#fff"
      />
      <path
        d="M154.324 63.96H98.449a1.797 1.797 0 100 3.593h55.875a1.797 1.797 0 100-3.594zM154.324 72.781H98.449a1.797 1.797 0 100 3.594h55.875a1.798 1.798 0 100-3.594zM154.324 81.604H98.449a1.797 1.797 0 100 3.594h55.875a1.798 1.798 0 100-3.594z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.131 35a12.525 12.525 0 00-2.194 2.73c-3.758 6.273-6.474 13.051-8.15 20.053-5.728-.805-11.288-1.992-16.52-3.563 5.722-9.758 15.417-16.905 26.864-19.22zm-28.92 23.298c5.585 1.725 11.532 3.025 17.662 3.9a74.23 74.23 0 000 25.557c-6.049.863-11.919 2.141-17.439 3.833a40.327 40.327 0 01-3.701-16.93 40.332 40.332 0 013.448-16.37l.03.01zm2.379 37.34c5.625 9.257 14.86 16.079 25.75 18.51a12.746 12.746 0 01-1.403-1.918c-3.759-6.276-6.476-13.056-8.151-20.06-5.611.788-11.059 1.944-16.196 3.468zm20.693-4.018a66.795 66.795 0 007.514 18.298h.001c2.972 4.964 9.826 4.964 12.798 0a66.766 66.766 0 007.515-18.298 135.267 135.267 0 00-27.828 0zm32.325.55c-1.675 7.004-4.392 13.785-8.151 20.06a12.782 12.782 0 01-1.402 1.917c10.889-2.432 20.122-9.254 25.746-18.51-5.136-1.524-10.584-2.679-16.193-3.467zm18.348-.584c-5.518-1.69-11.387-2.968-17.434-3.831a74.212 74.212 0 00-.002-25.558c6.128-.875 12.071-2.175 17.653-3.9l.035-.01a40.327 40.327 0 013.449 16.372 40.303 40.303 0 01-3.701 16.927zm-21.905-4.391a139.677 139.677 0 00-29.708 0 69.705 69.705 0 01.002-24.437 139.668 139.668 0 0029.705 0 69.732 69.732 0 01.001 24.437zm-28.766-28.862c9.17.956 18.655.955 27.824-.001a66.77 66.77 0 00-7.512-18.29h-.001c-2.976-4.965-9.827-4.964-12.798 0h-.001a66.784 66.784 0 00-7.512 18.29zm32.321-.55c5.728-.806 11.286-1.994 16.516-3.564-5.721-9.757-15.415-16.903-26.86-19.219.856.803 1.594 1.721 2.194 2.729h.001c3.757 6.274 6.474 13.051 8.149 20.053z"
        fill="#C1DEE2"
      />
      <defs>
        <linearGradient
          id="referral-empty_svg__paint0_linear_35_7633"
          x1={166.436}
          y1={155.99}
          x2={161.547}
          y2={178.991}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98D8FF" />
          <stop offset={1} stopColor="#5FB0FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgReferralEmpty;
